<footer class="fixed bottom-0 p-4 w-full">
  <div class="flex justify-content-center">
    <div class="border-round-2xl bg-white shadow-p-tabmenu px-3" style="height: 80px">
      <p-tabMenu [model]="items" [activeItem]="activeItem" id="tab_menu">
        <ng-template pTemplate="item" let-item>
          <a class="p-menuitem-link flex justify-content-between align-items-center p-3 font-bold">
            <div class="flex flex-column align-items-center" style="gap: 0.55rem;">
              <span [class]="item.icon"></span>
              <span class="text-center" style="font-size: 0.70rem"> {{ item.label }}</span>
            </div>
          </a>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
</footer>
